"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SocialGoogleColor = exports.ShareIcon = exports.SettingsAltIcon = exports.SettingsIcon = exports.SendIcon = exports.SellIcon = exports.SegmentsIcon = exports.SecuritiesIcon = exports.SearchSmartIcon = exports.SearchSimpleIcon = exports.SearchDeluxeIcon = exports.RupeeIcon = exports.RupeeCircleIcon = exports.RewardsIcon = exports.ReorderIcon = exports.RemoveIcon = exports.RemoveCircleIcon = exports.RefreshAltIcon = exports.RefreshIcon = exports.RadioUncheckedIcon = exports.RadioCheckedIcon = exports.PlayIcon = exports.PersonIcon = exports.PeopleIcon = exports.PauseIcon = exports.OpenIcon = exports.MutedIcon = exports.MyListsInactiveIcon = exports.MyListsActiveIcon = exports.LogoutIcon = exports.LoginIcon = exports.LockOpenedIcon = exports.LockClosedIcon = exports.LinkedAccountsIcon = exports.LineGraphIcon = exports.LanguageIcon = exports.InfoIcon = exports.InboxInactiveIcon = exports.InboxIcon = exports.InboxActiveIcon = exports.HindiIcon = exports.GitMergeIcon = exports.GiftIcon = exports.FlashIcon = exports.FingerprintIcon = exports.FeesIcon = exports.FaceIdIcon = exports.EyeonIcon = exports.EyeOffIcon = exports.ExpandAltIcon = exports.ExpandIcon = exports.ErrorCircleIcon = exports.EnglishIcon = exports.EllipsisVerticalIcon = exports.EllipsisIcon = exports.EditIcon = exports.DownvoteIcon = exports.DownstairsGraphIcon = exports.DiscoverInactiveIcon = exports.DiscoverActiveIcon = exports.DragIcon = exports.CopyIcon = exports.CopyActiveIcon = exports.CommoditiesIcon = exports.CollapseAltIcon = exports.CollapseIcon = exports.CloseAltIcon = exports.CloseIcon = exports.CloseCircleIcon = exports.ChevronUpIcon = exports.ChevronRightIcon = exports.ChevronLeftIcon = exports.ChevronDownIcon = exports.ChevronCircleUpIcon = exports.ChevronCircleDownIcon = exports.CheckboxSquareUncheckedIcon = exports.CheckboxSquareCheckedIcon = exports.CheckboxUncheckedIcon = exports.CheckboxCheckedIcon = exports.ChartTrendingIcon = exports.ChatIcon = exports.ChartIcon = exports.CashSharpIcon = exports.CameraIcon = exports.CalendarIcon = exports.BuyIcon = exports.BankDetailsIcon = exports.BankIcon = exports.ArrowRightCircleIcon = exports.ArrowLeftCircleIcon = exports.ArrowRightIcon = exports.ArrowRightAltIcon = exports.ArrowLeftIcon = exports.AroundCurrentGraphIcon = exports.AppOverviewIcon = exports.AlertSetIcon = exports.AlertIndicatorIcon = exports.AlertInactiveIcon = exports.AlertActiveIcon = exports.AddIcon = void 0;
exports.CloseOutlineIcon = exports.CommunityIcon = exports.DoubleArrowRightIcon = exports.DoubleArrowLeftIcon = exports.WarningAlertIcon = exports.ImageIcon = exports.LoadMoreAltVerticalIcon = exports.LoadMoreAltIcon = exports.LoadMoreIcon = exports.ExtremeGraphIcon = exports.WarningIcon = exports.VideoIcon = exports.UpvoteIcon = exports.TrendingUpIcon = exports.TrendingUpArrowIcon = exports.TrendingDownIcon = exports.TrendingDownArrowIcon = exports.TrashIcon = exports.TradingPlanIcon = exports.TradesInactiveIcon = exports.TradesActiveIcon = exports.TouchIdIcon = exports.TermsAndServicesIcon = exports.SwitchIcon = exports.SwitchAltIcon = exports.SupportIcon = exports.SupportCircleIcon = exports.SupportChatIcon = exports.SuitcaseIcon = exports.StopwatchIcon = exports.StatementsIcon = exports.StarInactiveIcon = exports.StarActiveIcon = exports.SortIcon = exports.SocialTwitter = exports.SocialFacebook = exports.SocialAppleIcon = exports.SocialGoogleIcon = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _addIcon = require("../../../asset/icon/add.icon.js");

var _alertActiveIcon = require("../../../asset/icon/alert-active.icon.js");

var _alertInactiveIcon = require("../../../asset/icon/alert-inactive.icon.js");

var _alertIndicatorIcon = require("../../../asset/icon/alert-indicator.icon.js");

var _alertSetIcon = require("../../../asset/icon/alert-set.icon.js");

var _appOverviewIcon = require("../../../asset/icon/app-overview.icon.js");

var _arrowLeftIcon = require("../../../asset/icon/arrow-left.icon.js");

var _arrowRightIcon = require("../../../asset/icon/arrow-right.icon.js");

var _arrowRightAltIcon = require("../../../asset/icon/arrow-right-alt.icon.js");

var _bankIcon = require("../../../asset/icon/bank.icon.js");

var _bankDetailsIcon = require("../../../asset/icon/bank-details.icon.js");

var _buyIcon = require("../../../asset/icon/buy.icon.js");

var _chartTrendingIcon = require("../../../asset/icon/chart-trending.icon.js");

var _calendarIcon = require("../../../asset/icon/calendar.icon.js");

var _cameraIcon = require("../../../asset/icon/camera.icon.js");

var _cashSharpIcon = require("../../../asset/icon/cash-sharp.icon.js");

var _chartIcon = require("../../../asset/icon/chart.icon.js");

var _chatIcon = require("../../../asset/icon/chat.icon.js");

var _checkboxCheckedIcon = require("../../../asset/icon/checkbox-checked.icon.js");

var _checkboxUncheckedIcon = require("../../../asset/icon/checkbox-unchecked.icon.js");

var _checkboxSquareCheckedIcon = require("../../../asset/icon/checkbox-square-checked.icon.js");

var _checkboxSquareUncheckedIcon = require("../../../asset/icon/checkbox-square-unchecked.icon.js");

var _chevronCircleDownIcon = require("../../../asset/icon/chevron-circle-down.icon.js");

var _chevronCircleUpIcon = require("../../../asset/icon/chevron-circle-up.icon.js");

var _chevronDownIcon = require("../../../asset/icon/chevron-down.icon.js");

var _chevronLeftIcon = require("../../../asset/icon/chevron-left.icon.js");

var _chevronRightIcon = require("../../../asset/icon/chevron-right.icon.js");

var _chevronUpIcon = require("../../../asset/icon/chevron-up.icon.js");

var _closeIcon = require("../../../asset/icon/close.icon.js");

var _closeAltIcon = require("../../../asset/icon/close-alt.icon.js");

var _closeCircleIcon = require("../../../asset/icon/close-circle.icon.js");

var _collapseIcon = require("../../../asset/icon/collapse.icon.js");

var _collapseAltIcon = require("../../../asset/icon/collapse-alt.icon.js");

var _commoditiesIcon = require("../../../asset/icon/commodities.icon.js");

var _copyIcon = require("../../../asset/icon/copy.icon.js");

var _copyActiveIcon = require("../../../asset/icon/copy-active.icon.js");

var _dragIcon = require("../../../asset/icon/drag.icon.js");

var _discoverActiveIcon = require("../../../asset/icon/discover-active.icon.js");

var _discoverInactiveIcon = require("../../../asset/icon/discover-inactive.icon.js");

var _downvoteIcon = require("../../../asset/icon/downvote.icon.js");

var _editIcon = require("../../../asset/icon/edit.icon.js");

var _ellipsisIcon = require("../../../asset/icon/ellipsis.icon.js");

var _ellipsisVerticalIcon = require("../../../asset/icon/ellipsis-vertical.icon.js");

var _englishIcon = require("../../../asset/icon/english.icon.js");

var _errorCircleIcon = require("../../../asset/icon/error-circle.icon.js");

var _expandIcon = require("../../../asset/icon/expand.icon.js");

var _expandAltIcon = require("../../../asset/icon/expand-alt.icon.js");

var _eyeOffIcon = require("../../../asset/icon/eye-off.icon.js");

var _eyeOnIcon = require("../../../asset/icon/eye-on.icon.js");

var _faceIdIcon = require("../../../asset/icon/face-id.icon.js");

var _feesIcon = require("../../../asset/icon/fees.icon.js");

var _fingerprintIcon = require("../../../asset/icon/fingerprint.icon.js");

var _flashIcon = require("../../../asset/icon/flash.icon.js");

var _giftIcon = require("../../../asset/icon/gift.icon.js");

var _gitMergeSharpIcon = require("../../../asset/icon/git-merge-sharp.icon.js");

var _hindiIcon = require("../../../asset/icon/hindi.icon.js");

var _inboxIcon = require("../../../asset/icon/inbox.icon.js");

var _inboxActiveIcon = require("../../../asset/icon/inbox-active.icon.js");

var _inboxInactiveIcon = require("../../../asset/icon/inbox-inactive.icon.js");

var _informationIcon = require("../../../asset/icon/information.icon.js");

var _languageIcon = require("../../../asset/icon/language.icon.js");

var _lineGraphIcon = require("../../../asset/icon/line-graph.icon.js");

var _linkedAccountsIcon = require("../../../asset/icon/linked-accounts.icon.js");

var _lockClosedIcon = require("../../../asset/icon/lock-closed.icon.js");

var _lockOpenedIcon = require("../../../asset/icon/lock-opened.icon.js");

var _logInIcon = require("../../../asset/icon/log-in.icon.js");

var _logOutIcon = require("../../../asset/icon/log-out.icon.js");

var _myListsActiveIcon = require("../../../asset/icon/my-lists-active.icon.js");

var _myListsInactiveIcon = require("../../../asset/icon/my-lists-inactive.icon.js");

var _openIcon = require("../../../asset/icon/open.icon.js");

var _pauseIcon = require("../../../asset/icon/pause.icon.js");

var _peopleIcon = require("../../../asset/icon/people.icon.js");

var _personIcon = require("../../../asset/icon/person.icon.js");

var _playIcon = require("../../../asset/icon/play.icon.js");

var _radioCheckedIcon = require("../../../asset/icon/radio-checked.icon.js");

var _radioUncheckedIcon = require("../../../asset/icon/radio-unchecked.icon.js");

var _refreshIcon = require("../../../asset/icon/refresh.icon.js");

var _refreshAltIcon = require("../../../asset/icon/refresh-alt.icon.js");

var _removeIcon = require("../../../asset/icon/remove.icon.js");

var _removeCircleIcon = require("../../../asset/icon/remove-circle.icon.js");

var _reorderIcon = require("../../../asset/icon/reorder.icon.js");

var _rewardsIcon = require("../../../asset/icon/rewards.icon.js");

var _rupeeIcon = require("../../../asset/icon/rupee.icon.js");

var _rupeeCircle = _interopRequireWildcard(require("../../../asset/icon/rupee-circle.svg"));

var _searchDeluxeIcon = require("../../../asset/icon/search-deluxe.icon.js");

var _searchSimpleIcon = require("../../../asset/icon/search-simple.icon.js");

var _searchSmartIcon = require("../../../asset/icon/search-smart.icon.js");

var _securitiesIcon = require("../../../asset/icon/securities.icon.js");

var _segmentsIcon = require("../../../asset/icon/segments.icon.js");

var _sellIcon = require("../../../asset/icon/sell.icon.js");

var _sendIcon = require("../../../asset/icon/send.icon.js");

var _settingsIcon = require("../../../asset/icon/settings.icon.js");

var _settingsAltIcon = require("../../../asset/icon/settings-alt.icon.js");

var _shareIcon = require("../../../asset/icon/share.icon.js");

var _socialGoogleDefault = require("../../../asset/icon/social-google-default.svg");

var _socialApple = require("../../../asset/icon/social-apple.svg");

var _socialFacebook = require("../../../asset/icon/social-facebook.svg");

var _socialTwitter = require("../../../asset/icon/social-twitter.svg");

var _socialGoogleColor = _interopRequireWildcard(require("../../../asset/icon/social-google-color.svg"));

var _sortIcon = require("../../../asset/icon/sort.icon.js");

var _starActiveIcon = require("../../../asset/icon/star-active.icon.js");

var _starInactiveIcon = require("../../../asset/icon/star-inactive.icon.js");

var _statementsIcon = require("../../../asset/icon/statements.icon.js");

var _stopwatchIcon = require("../../../asset/icon/stopwatch.icon.js");

var _suitcaseIcon = require("../../../asset/icon/suitcase.icon.js");

var _supportIcon = require("../../../asset/icon/support.icon.js");

var _supportChatIcon = require("../../../asset/icon/support-chat.icon.js");

var _supportCircleIcon = require("../../../asset/icon/support-circle.icon.js");

var _switchAltIcon = require("../../../asset/icon/switch-alt.icon.js");

var _switchIcon = require("../../../asset/icon/switch.icon.js");

var _termsAndServicesIcon = require("../../../asset/icon/terms-and-services.icon.js");

var _touchIdIcon = require("../../../asset/icon/touch-id.icon.js");

var _tradesActiveIcon = require("../../../asset/icon/trades-active.icon.js");

var _tradesInactiveIcon = require("../../../asset/icon/trades-inactive.icon.js");

var _tradingPlanIcon = require("../../../asset/icon/trading-plan.icon.js");

var _trashIcon = require("../../../asset/icon/trash.icon.js");

var _trendingDownIcon = require("../../../asset/icon/trending-down.icon.js");

var _trendingDownArrowIcon = require("../../../asset/icon/trending-down-arrow.icon.js");

var _trendingUpIcon = require("../../../asset/icon/trending-up.icon.js");

var _trendingUpArrowIcon = require("../../../asset/icon/trending-up-arrow.icon.js");

var _upvoteIcon = require("../../../asset/icon/upvote.icon.js");

var _videoIcon = require("../../../asset/icon/video.icon.js");

var _warningIcon = require("../../../asset/icon/warning.icon.js");

var _imageIcon = require("../../../asset/icon/image.icon.js");

var _mutedIcon = require("../../../asset/icon/muted.icon.js");

var _arrowLeftCircleIcon = require("../../../asset/icon/arrow-left-circle.icon.js");

var _arrowRightCircleIcon = require("../../../asset/icon/arrow-right-circle.icon.js");

var _aroundCurrentGraphIcon = require("../../../asset/icon/around-current-graph.icon.js");

var _downstairsGraphIcon = require("../../../asset/icon/downstairs-graph.icon.js");

var _extremeGraphIcon = require("../../../asset/icon/extreme-graph.icon.js");

var _warningAlertIcon = require("../../../asset/icon/warning-alert.icon.js");

var _doubleArrowLeftIcon = require("../../../asset/icon/double-arrow-left.icon.js");

var _doubleArrowRightIcon = require("../../../asset/icon/double-arrow-right.icon.js");

var _communityIcon = require("../../../asset/icon/community.icon.js");

var _closeOutlineIcon = require("../../../asset/icon/close-outline.icon.js");

var _Icon = require("./Icon.style");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const ICON_NAME_MAP = {
  SocialGoogleColor: _socialGoogleColor.default,
  RupeeCircleIcon: _rupeeCircle.default
};

const createIconComponent = (Icon, ImageIconName) => ({
  color,
  size = 'inline',
  width,
  height,
  ...otherProps
}) => {
  if (ImageIconName) {
    return (0, _pragma.createFelaElement)("img", {
      "aria-hidden": true,
      alt: ImageIconName,
      cssProps: {
        size,
        width,
        height
      },
      css: _Icon.css,
      loading: "lazy",
      src: ICON_NAME_MAP[ImageIconName]
    });
  }

  return (0, _pragma.createFelaElement)(Icon, _extends({
    "aria-hidden": true,
    css: _Icon.css,
    cssProps: {
      color,
      size,
      width,
      height
    },
    focusable: "false"
  }, otherProps));
};
/**
 * Icons are used to represent common actions, such as "Add/Remove",
 * "Open/Close", or concepts such as "Location" or "User". The component
 * renders an inline SVG. Where possible, it is preferable to import and use
 * only the individual Icon components required.
 *
 * All props are forwarded to the inner `<svg>` element. This includes all
 * appropriate HTML attributes or aria tags.
 */


const AddIcon = createIconComponent(_addIcon.ReactComponent);
exports.AddIcon = AddIcon;
const AlertActiveIcon = createIconComponent(_alertActiveIcon.ReactComponent);
exports.AlertActiveIcon = AlertActiveIcon;
const AlertInactiveIcon = createIconComponent(_alertInactiveIcon.ReactComponent);
exports.AlertInactiveIcon = AlertInactiveIcon;
const AlertIndicatorIcon = createIconComponent(_alertIndicatorIcon.ReactComponent);
exports.AlertIndicatorIcon = AlertIndicatorIcon;
const AlertSetIcon = createIconComponent(_alertSetIcon.ReactComponent);
exports.AlertSetIcon = AlertSetIcon;
const AppOverviewIcon = createIconComponent(_appOverviewIcon.ReactComponent);
exports.AppOverviewIcon = AppOverviewIcon;
const AroundCurrentGraphIcon = createIconComponent(_aroundCurrentGraphIcon.ReactComponent);
exports.AroundCurrentGraphIcon = AroundCurrentGraphIcon;
const ArrowLeftIcon = createIconComponent(_arrowLeftIcon.ReactComponent);
exports.ArrowLeftIcon = ArrowLeftIcon;
const ArrowRightAltIcon = createIconComponent(_arrowRightAltIcon.ReactComponent);
exports.ArrowRightAltIcon = ArrowRightAltIcon;
const ArrowRightIcon = createIconComponent(_arrowRightIcon.ReactComponent);
exports.ArrowRightIcon = ArrowRightIcon;
const ArrowLeftCircleIcon = createIconComponent(_arrowLeftCircleIcon.ReactComponent);
exports.ArrowLeftCircleIcon = ArrowLeftCircleIcon;
const ArrowRightCircleIcon = createIconComponent(_arrowRightCircleIcon.ReactComponent);
exports.ArrowRightCircleIcon = ArrowRightCircleIcon;
const BankIcon = createIconComponent(_bankIcon.ReactComponent);
exports.BankIcon = BankIcon;
const BankDetailsIcon = createIconComponent(_bankDetailsIcon.ReactComponent);
exports.BankDetailsIcon = BankDetailsIcon;
const BuyIcon = createIconComponent(_buyIcon.ReactComponent);
exports.BuyIcon = BuyIcon;
const CalendarIcon = createIconComponent(_calendarIcon.ReactComponent);
exports.CalendarIcon = CalendarIcon;
const CameraIcon = createIconComponent(_cameraIcon.ReactComponent);
exports.CameraIcon = CameraIcon;
const CashSharpIcon = createIconComponent(_cashSharpIcon.ReactComponent);
exports.CashSharpIcon = CashSharpIcon;
const ChartIcon = createIconComponent(_chartIcon.ReactComponent);
exports.ChartIcon = ChartIcon;
const ChatIcon = createIconComponent(_chatIcon.ReactComponent);
exports.ChatIcon = ChatIcon;
const ChartTrendingIcon = createIconComponent(_chartTrendingIcon.ReactComponent);
exports.ChartTrendingIcon = ChartTrendingIcon;
const CheckboxCheckedIcon = createIconComponent(_checkboxCheckedIcon.ReactComponent);
exports.CheckboxCheckedIcon = CheckboxCheckedIcon;
const CheckboxUncheckedIcon = createIconComponent(_checkboxUncheckedIcon.ReactComponent);
exports.CheckboxUncheckedIcon = CheckboxUncheckedIcon;
const CheckboxSquareCheckedIcon = createIconComponent(_checkboxSquareCheckedIcon.ReactComponent);
exports.CheckboxSquareCheckedIcon = CheckboxSquareCheckedIcon;
const CheckboxSquareUncheckedIcon = createIconComponent(_checkboxSquareUncheckedIcon.ReactComponent);
exports.CheckboxSquareUncheckedIcon = CheckboxSquareUncheckedIcon;
const ChevronCircleDownIcon = createIconComponent(_chevronCircleDownIcon.ReactComponent);
exports.ChevronCircleDownIcon = ChevronCircleDownIcon;
const ChevronCircleUpIcon = createIconComponent(_chevronCircleUpIcon.ReactComponent);
exports.ChevronCircleUpIcon = ChevronCircleUpIcon;
const ChevronDownIcon = createIconComponent(_chevronDownIcon.ReactComponent);
exports.ChevronDownIcon = ChevronDownIcon;
const ChevronLeftIcon = createIconComponent(_chevronLeftIcon.ReactComponent);
exports.ChevronLeftIcon = ChevronLeftIcon;
const ChevronRightIcon = createIconComponent(_chevronRightIcon.ReactComponent);
exports.ChevronRightIcon = ChevronRightIcon;
const ChevronUpIcon = createIconComponent(_chevronUpIcon.ReactComponent);
exports.ChevronUpIcon = ChevronUpIcon;
const CloseCircleIcon = createIconComponent(_closeCircleIcon.ReactComponent);
exports.CloseCircleIcon = CloseCircleIcon;
const CloseIcon = createIconComponent(_closeIcon.ReactComponent);
exports.CloseIcon = CloseIcon;
const CloseAltIcon = createIconComponent(_closeAltIcon.ReactComponent);
exports.CloseAltIcon = CloseAltIcon;
const CollapseIcon = createIconComponent(_collapseIcon.ReactComponent);
exports.CollapseIcon = CollapseIcon;
const CollapseAltIcon = createIconComponent(_collapseAltIcon.ReactComponent);
exports.CollapseAltIcon = CollapseAltIcon;
const CommoditiesIcon = createIconComponent(_commoditiesIcon.ReactComponent);
exports.CommoditiesIcon = CommoditiesIcon;
const CopyActiveIcon = createIconComponent(_copyActiveIcon.ReactComponent);
exports.CopyActiveIcon = CopyActiveIcon;
const CopyIcon = createIconComponent(_copyIcon.ReactComponent);
exports.CopyIcon = CopyIcon;
const DragIcon = createIconComponent(_dragIcon.ReactComponent);
exports.DragIcon = DragIcon;
const DiscoverActiveIcon = createIconComponent(_discoverActiveIcon.ReactComponent);
exports.DiscoverActiveIcon = DiscoverActiveIcon;
const DiscoverInactiveIcon = createIconComponent(_discoverInactiveIcon.ReactComponent);
exports.DiscoverInactiveIcon = DiscoverInactiveIcon;
const DownstairsGraphIcon = createIconComponent(_downstairsGraphIcon.ReactComponent);
exports.DownstairsGraphIcon = DownstairsGraphIcon;
const DownvoteIcon = createIconComponent(_downvoteIcon.ReactComponent);
exports.DownvoteIcon = DownvoteIcon;
const EditIcon = createIconComponent(_editIcon.ReactComponent);
exports.EditIcon = EditIcon;
const EllipsisIcon = createIconComponent(_ellipsisIcon.ReactComponent);
exports.EllipsisIcon = EllipsisIcon;
const EllipsisVerticalIcon = createIconComponent(_ellipsisVerticalIcon.ReactComponent);
exports.EllipsisVerticalIcon = EllipsisVerticalIcon;
const EnglishIcon = createIconComponent(_englishIcon.ReactComponent);
exports.EnglishIcon = EnglishIcon;
const ErrorCircleIcon = createIconComponent(_errorCircleIcon.ReactComponent);
exports.ErrorCircleIcon = ErrorCircleIcon;
const ExpandIcon = createIconComponent(_expandIcon.ReactComponent);
exports.ExpandIcon = ExpandIcon;
const ExpandAltIcon = createIconComponent(_expandAltIcon.ReactComponent);
exports.ExpandAltIcon = ExpandAltIcon;
const EyeOffIcon = createIconComponent(_eyeOffIcon.ReactComponent);
exports.EyeOffIcon = EyeOffIcon;
const EyeonIcon = createIconComponent(_eyeOnIcon.ReactComponent);
exports.EyeonIcon = EyeonIcon;
const FaceIdIcon = createIconComponent(_faceIdIcon.ReactComponent);
exports.FaceIdIcon = FaceIdIcon;
const FeesIcon = createIconComponent(_feesIcon.ReactComponent);
exports.FeesIcon = FeesIcon;
const FingerprintIcon = createIconComponent(_fingerprintIcon.ReactComponent);
exports.FingerprintIcon = FingerprintIcon;
const FlashIcon = createIconComponent(_flashIcon.ReactComponent);
exports.FlashIcon = FlashIcon;
const GiftIcon = createIconComponent(_giftIcon.ReactComponent);
exports.GiftIcon = GiftIcon;
const GitMergeIcon = createIconComponent(_gitMergeSharpIcon.ReactComponent);
exports.GitMergeIcon = GitMergeIcon;
const HindiIcon = createIconComponent(_hindiIcon.ReactComponent);
exports.HindiIcon = HindiIcon;
const InboxActiveIcon = createIconComponent(_inboxActiveIcon.ReactComponent);
exports.InboxActiveIcon = InboxActiveIcon;
const InboxIcon = createIconComponent(_inboxIcon.ReactComponent);
exports.InboxIcon = InboxIcon;
const InboxInactiveIcon = createIconComponent(_inboxInactiveIcon.ReactComponent);
exports.InboxInactiveIcon = InboxInactiveIcon;
const InfoIcon = createIconComponent(_informationIcon.ReactComponent);
exports.InfoIcon = InfoIcon;
const LanguageIcon = createIconComponent(_languageIcon.ReactComponent);
exports.LanguageIcon = LanguageIcon;
const LineGraphIcon = createIconComponent(_lineGraphIcon.ReactComponent);
exports.LineGraphIcon = LineGraphIcon;
const LinkedAccountsIcon = createIconComponent(_linkedAccountsIcon.ReactComponent);
exports.LinkedAccountsIcon = LinkedAccountsIcon;
const LockClosedIcon = createIconComponent(_lockClosedIcon.ReactComponent);
exports.LockClosedIcon = LockClosedIcon;
const LockOpenedIcon = createIconComponent(_lockOpenedIcon.ReactComponent);
exports.LockOpenedIcon = LockOpenedIcon;
const LoginIcon = createIconComponent(_logInIcon.ReactComponent);
exports.LoginIcon = LoginIcon;
const LogoutIcon = createIconComponent(_logOutIcon.ReactComponent);
exports.LogoutIcon = LogoutIcon;
const MyListsActiveIcon = createIconComponent(_myListsActiveIcon.ReactComponent);
exports.MyListsActiveIcon = MyListsActiveIcon;
const MyListsInactiveIcon = createIconComponent(_myListsInactiveIcon.ReactComponent);
exports.MyListsInactiveIcon = MyListsInactiveIcon;
const MutedIcon = createIconComponent(_mutedIcon.ReactComponent);
exports.MutedIcon = MutedIcon;
const OpenIcon = createIconComponent(_openIcon.ReactComponent);
exports.OpenIcon = OpenIcon;
const PauseIcon = createIconComponent(_pauseIcon.ReactComponent);
exports.PauseIcon = PauseIcon;
const PeopleIcon = createIconComponent(_peopleIcon.ReactComponent);
exports.PeopleIcon = PeopleIcon;
const PersonIcon = createIconComponent(_personIcon.ReactComponent);
exports.PersonIcon = PersonIcon;
const PlayIcon = createIconComponent(_playIcon.ReactComponent);
exports.PlayIcon = PlayIcon;
const RadioCheckedIcon = createIconComponent(_radioCheckedIcon.ReactComponent);
exports.RadioCheckedIcon = RadioCheckedIcon;
const RadioUncheckedIcon = createIconComponent(_radioUncheckedIcon.ReactComponent);
exports.RadioUncheckedIcon = RadioUncheckedIcon;
const RefreshIcon = createIconComponent(_refreshIcon.ReactComponent);
exports.RefreshIcon = RefreshIcon;
const RefreshAltIcon = createIconComponent(_refreshAltIcon.ReactComponent);
exports.RefreshAltIcon = RefreshAltIcon;
const RemoveCircleIcon = createIconComponent(_removeCircleIcon.ReactComponent);
exports.RemoveCircleIcon = RemoveCircleIcon;
const RemoveIcon = createIconComponent(_removeIcon.ReactComponent);
exports.RemoveIcon = RemoveIcon;
const ReorderIcon = createIconComponent(_reorderIcon.ReactComponent);
exports.ReorderIcon = ReorderIcon;
const RewardsIcon = createIconComponent(_rewardsIcon.ReactComponent);
exports.RewardsIcon = RewardsIcon;
const RupeeCircleIcon = createIconComponent(_rupeeCircle.ReactComponent, 'RupeeCircleIcon');
exports.RupeeCircleIcon = RupeeCircleIcon;
const RupeeIcon = createIconComponent(_rupeeIcon.ReactComponent);
exports.RupeeIcon = RupeeIcon;
const SearchDeluxeIcon = createIconComponent(_searchDeluxeIcon.ReactComponent);
exports.SearchDeluxeIcon = SearchDeluxeIcon;
const SearchSimpleIcon = createIconComponent(_searchSimpleIcon.ReactComponent);
exports.SearchSimpleIcon = SearchSimpleIcon;
const SearchSmartIcon = createIconComponent(_searchSmartIcon.ReactComponent);
exports.SearchSmartIcon = SearchSmartIcon;
const SecuritiesIcon = createIconComponent(_securitiesIcon.ReactComponent);
exports.SecuritiesIcon = SecuritiesIcon;
const SegmentsIcon = createIconComponent(_segmentsIcon.ReactComponent);
exports.SegmentsIcon = SegmentsIcon;
const SellIcon = createIconComponent(_sellIcon.ReactComponent);
exports.SellIcon = SellIcon;
const SendIcon = createIconComponent(_sendIcon.ReactComponent);
exports.SendIcon = SendIcon;
const SettingsIcon = createIconComponent(_settingsIcon.ReactComponent);
exports.SettingsIcon = SettingsIcon;
const SettingsAltIcon = createIconComponent(_settingsAltIcon.ReactComponent);
exports.SettingsAltIcon = SettingsAltIcon;
const ShareIcon = createIconComponent(_shareIcon.ReactComponent);
exports.ShareIcon = ShareIcon;
const SocialGoogleColor = createIconComponent(_socialGoogleColor.ReactComponent, 'SocialGoogleColor');
exports.SocialGoogleColor = SocialGoogleColor;
const SocialGoogleIcon = createIconComponent(_socialGoogleDefault.ReactComponent);
exports.SocialGoogleIcon = SocialGoogleIcon;
const SocialAppleIcon = createIconComponent(_socialApple.ReactComponent);
exports.SocialAppleIcon = SocialAppleIcon;
const SocialFacebook = createIconComponent(_socialFacebook.ReactComponent);
exports.SocialFacebook = SocialFacebook;
const SocialTwitter = createIconComponent(_socialTwitter.ReactComponent);
exports.SocialTwitter = SocialTwitter;
const SortIcon = createIconComponent(_sortIcon.ReactComponent);
exports.SortIcon = SortIcon;
const StarActiveIcon = createIconComponent(_starActiveIcon.ReactComponent);
exports.StarActiveIcon = StarActiveIcon;
const StarInactiveIcon = createIconComponent(_starInactiveIcon.ReactComponent);
exports.StarInactiveIcon = StarInactiveIcon;
const StatementsIcon = createIconComponent(_statementsIcon.ReactComponent);
exports.StatementsIcon = StatementsIcon;
const StopwatchIcon = createIconComponent(_stopwatchIcon.ReactComponent);
exports.StopwatchIcon = StopwatchIcon;
const SuitcaseIcon = createIconComponent(_suitcaseIcon.ReactComponent);
exports.SuitcaseIcon = SuitcaseIcon;
const SupportChatIcon = createIconComponent(_supportChatIcon.ReactComponent);
exports.SupportChatIcon = SupportChatIcon;
const SupportCircleIcon = createIconComponent(_supportCircleIcon.ReactComponent);
exports.SupportCircleIcon = SupportCircleIcon;
const SupportIcon = createIconComponent(_supportIcon.ReactComponent);
exports.SupportIcon = SupportIcon;
const SwitchAltIcon = createIconComponent(_switchAltIcon.ReactComponent);
exports.SwitchAltIcon = SwitchAltIcon;
const SwitchIcon = createIconComponent(_switchIcon.ReactComponent);
exports.SwitchIcon = SwitchIcon;
const TermsAndServicesIcon = createIconComponent(_termsAndServicesIcon.ReactComponent);
exports.TermsAndServicesIcon = TermsAndServicesIcon;
const TouchIdIcon = createIconComponent(_touchIdIcon.ReactComponent);
exports.TouchIdIcon = TouchIdIcon;
const TradesActiveIcon = createIconComponent(_tradesActiveIcon.ReactComponent);
exports.TradesActiveIcon = TradesActiveIcon;
const TradesInactiveIcon = createIconComponent(_tradesInactiveIcon.ReactComponent);
exports.TradesInactiveIcon = TradesInactiveIcon;
const TradingPlanIcon = createIconComponent(_tradingPlanIcon.ReactComponent);
exports.TradingPlanIcon = TradingPlanIcon;
const TrashIcon = createIconComponent(_trashIcon.ReactComponent);
exports.TrashIcon = TrashIcon;
const TrendingDownArrowIcon = createIconComponent(_trendingDownArrowIcon.ReactComponent);
exports.TrendingDownArrowIcon = TrendingDownArrowIcon;
const TrendingDownIcon = createIconComponent(_trendingDownIcon.ReactComponent);
exports.TrendingDownIcon = TrendingDownIcon;
const TrendingUpArrowIcon = createIconComponent(_trendingUpArrowIcon.ReactComponent);
exports.TrendingUpArrowIcon = TrendingUpArrowIcon;
const TrendingUpIcon = createIconComponent(_trendingUpIcon.ReactComponent);
exports.TrendingUpIcon = TrendingUpIcon;
const UpvoteIcon = createIconComponent(_upvoteIcon.ReactComponent);
exports.UpvoteIcon = UpvoteIcon;
const VideoIcon = createIconComponent(_videoIcon.ReactComponent);
exports.VideoIcon = VideoIcon;
const WarningIcon = createIconComponent(_warningIcon.ReactComponent);
exports.WarningIcon = WarningIcon;
const ExtremeGraphIcon = createIconComponent(_extremeGraphIcon.ReactComponent);
exports.ExtremeGraphIcon = ExtremeGraphIcon;
const LoadMoreIcon = RefreshIcon;
exports.LoadMoreIcon = LoadMoreIcon;
const LoadMoreAltIcon = EllipsisIcon;
exports.LoadMoreAltIcon = LoadMoreAltIcon;
const LoadMoreAltVerticalIcon = EllipsisVerticalIcon;
exports.LoadMoreAltVerticalIcon = LoadMoreAltVerticalIcon;
const ImageIcon = createIconComponent(_imageIcon.ReactComponent);
exports.ImageIcon = ImageIcon;
const WarningAlertIcon = createIconComponent(_warningAlertIcon.ReactComponent);
exports.WarningAlertIcon = WarningAlertIcon;
const DoubleArrowLeftIcon = createIconComponent(_doubleArrowLeftIcon.ReactComponent);
exports.DoubleArrowLeftIcon = DoubleArrowLeftIcon;
const DoubleArrowRightIcon = createIconComponent(_doubleArrowRightIcon.ReactComponent);
exports.DoubleArrowRightIcon = DoubleArrowRightIcon;
const CommunityIcon = createIconComponent(_communityIcon.ReactComponent);
exports.CommunityIcon = CommunityIcon;
const CloseOutlineIcon = createIconComponent(_closeOutlineIcon.ReactComponent);
exports.CloseOutlineIcon = CloseOutlineIcon;
//# sourceMappingURL=Icon.js.map